import OrgDetailComponent from './_orgDetailComponent';
import { RouteComponentProps, withRouter } from 'react-router';

function OrganisationDetailPage(props: RouteComponentProps<{ id: string }>): JSX.Element {
  const id = props.match.params.id;

  return <OrgDetailComponent id={id} />;
}

export default withRouter(OrganisationDetailPage);
